'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00241 from "./mealorama.-Meal-Course$$anon$1.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002410 from "./mealorama.-Meal-Course$$anon$10.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002411 from "./mealorama.-Meal-Course$$anon$11.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002412 from "./mealorama.-Meal-Course$$anon$12.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002413 from "./mealorama.-Meal-Course$$anon$13.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002414 from "./mealorama.-Meal-Course$$anon$14.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002415 from "./mealorama.-Meal-Course$$anon$15.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002416 from "./mealorama.-Meal-Course$$anon$16.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00242 from "./mealorama.-Meal-Course$$anon$2.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00243 from "./mealorama.-Meal-Course$$anon$3.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00244 from "./mealorama.-Meal-Course$$anon$4.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00245 from "./mealorama.-Meal-Course$$anon$5.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00246 from "./mealorama.-Meal-Course$$anon$6.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00247 from "./mealorama.-Meal-Course$$anon$7.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00248 from "./mealorama.-Meal-Course$$anon$8.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00249 from "./mealorama.-Meal-Course$$anon$9.js";
import * as $j_mealorama$002e$002dMeal$002dCourse$0024other from "./mealorama.-Meal-Course$other.js";
var $p;
function $s_Lmealorama_MealCourse$__amuseBouche__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__amuseBouche;
}
export { $s_Lmealorama_MealCourse$__amuseBouche__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__amuseBouche__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__appetizer__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__appetizer;
}
export { $s_Lmealorama_MealCourse$__appetizer__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__appetizer__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__soup__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__soup;
}
export { $s_Lmealorama_MealCourse$__soup__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__soup__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__fish__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__fish;
}
export { $s_Lmealorama_MealCourse$__fish__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__fish__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__salad__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__salad;
}
export { $s_Lmealorama_MealCourse$__salad__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__salad__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__mainCourse__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__mainCourse;
}
export { $s_Lmealorama_MealCourse$__mainCourse__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__mainCourse__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__dessert__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__dessert;
}
export { $s_Lmealorama_MealCourse$__dessert__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__dessert__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__cocktail__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__cocktail;
}
export { $s_Lmealorama_MealCourse$__cocktail__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__cocktail__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__canape__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__canape;
}
export { $s_Lmealorama_MealCourse$__canape__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__canape__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__bread__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__bread;
}
export { $s_Lmealorama_MealCourse$__bread__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__bread__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__snack__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__snack;
}
export { $s_Lmealorama_MealCourse$__snack__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__snack__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__preserve__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__preserve;
}
export { $s_Lmealorama_MealCourse$__preserve__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__preserve__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__candy__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__candy;
}
export { $s_Lmealorama_MealCourse$__candy__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__candy__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__sauce__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__sauce;
}
export { $s_Lmealorama_MealCourse$__sauce__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__sauce__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__sideDish__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__sideDish;
}
export { $s_Lmealorama_MealCourse$__sideDish__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__sideDish__Lmealorama_MealCourse };
function $s_Lmealorama_MealCourse$__subIngredient__Lmealorama_MealCourse() {
  $m_Lmealorama_MealCourse$();
  return $t_Lmealorama_MealCourse$__subIngredient;
}
export { $s_Lmealorama_MealCourse$__subIngredient__Lmealorama_MealCourse as $s_Lmealorama_MealCourse$__subIngredient__Lmealorama_MealCourse };
/** @constructor */
function $c_Lmealorama_MealCourse$() {
  this.alL = null;
  this.alM = false;
  $n_Lmealorama_MealCourse$ = this;
  $t_Lmealorama_MealCourse$__amuseBouche = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00241.$c_Lmealorama_MealCourse$$anon$1();
  $t_Lmealorama_MealCourse$__appetizer = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00242.$c_Lmealorama_MealCourse$$anon$2();
  $t_Lmealorama_MealCourse$__soup = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00243.$c_Lmealorama_MealCourse$$anon$3();
  $t_Lmealorama_MealCourse$__fish = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00244.$c_Lmealorama_MealCourse$$anon$4();
  $t_Lmealorama_MealCourse$__salad = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00245.$c_Lmealorama_MealCourse$$anon$5();
  $t_Lmealorama_MealCourse$__mainCourse = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00246.$c_Lmealorama_MealCourse$$anon$6();
  $t_Lmealorama_MealCourse$__dessert = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00247.$c_Lmealorama_MealCourse$$anon$7();
  $t_Lmealorama_MealCourse$__cocktail = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00248.$c_Lmealorama_MealCourse$$anon$8();
  $t_Lmealorama_MealCourse$__canape = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$00249.$c_Lmealorama_MealCourse$$anon$9();
  $t_Lmealorama_MealCourse$__bread = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002410.$c_Lmealorama_MealCourse$$anon$10();
  $t_Lmealorama_MealCourse$__snack = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002411.$c_Lmealorama_MealCourse$$anon$11();
  $t_Lmealorama_MealCourse$__preserve = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002412.$c_Lmealorama_MealCourse$$anon$12();
  $t_Lmealorama_MealCourse$__candy = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002413.$c_Lmealorama_MealCourse$$anon$13();
  $t_Lmealorama_MealCourse$__sauce = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002414.$c_Lmealorama_MealCourse$$anon$14();
  $t_Lmealorama_MealCourse$__sideDish = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002415.$c_Lmealorama_MealCourse$$anon$15();
  $t_Lmealorama_MealCourse$__subIngredient = new $j_mealorama$002e$002dMeal$002dCourse$0024$0024anon$002416.$c_Lmealorama_MealCourse$$anon$16();
}
export { $c_Lmealorama_MealCourse$ as $c_Lmealorama_MealCourse$ };
$p = $c_Lmealorama_MealCourse$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealCourse$;
/** @constructor */
function $h_Lmealorama_MealCourse$() {
}
export { $h_Lmealorama_MealCourse$ as $h_Lmealorama_MealCourse$ };
$h_Lmealorama_MealCourse$.prototype = $p;
$p.a4f = (function() {
  if ((!this.alM)) {
    this.alL = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Seq$().HH($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_WrappedVarArgs(), [$s_Lmealorama_MealCourse$__amuseBouche__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__appetizer__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__soup__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__fish__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__salad__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__mainCourse__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__dessert__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__cocktail__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__canape__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__bread__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__snack__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__preserve__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__candy__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__sauce__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__sideDish__Lmealorama_MealCourse(), $s_Lmealorama_MealCourse$__subIngredient__Lmealorama_MealCourse()]));
    this.alM = true;
  }
  return this.alL;
});
$p.a2t = (function(name) {
  var this$2 = this.a4f().l9(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => (_$1$2.hE() === name))));
  return (this$2.b() ? new $j_mealorama$002e$002dMeal$002dCourse$0024other.$c_Lmealorama_MealCourse$other(name) : this$2.i());
});
var $d_Lmealorama_MealCourse$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealCourse$, "mealorama.MealCourse$", ({
  FW: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_MealCourse$ as $d_Lmealorama_MealCourse$ };
var $n_Lmealorama_MealCourse$;
function $m_Lmealorama_MealCourse$() {
  if ((!$n_Lmealorama_MealCourse$)) {
    $n_Lmealorama_MealCourse$ = new $c_Lmealorama_MealCourse$();
  }
  return $n_Lmealorama_MealCourse$;
}
export { $m_Lmealorama_MealCourse$ as $m_Lmealorama_MealCourse$ };
var $t_Lmealorama_MealCourse$__amuseBouche = null;
function $u_Lmealorama_MealCourse$__amuseBouche(x) {
  $t_Lmealorama_MealCourse$__amuseBouche = x;
}
export { $t_Lmealorama_MealCourse$__amuseBouche as $t_Lmealorama_MealCourse$__amuseBouche, $u_Lmealorama_MealCourse$__amuseBouche as $u_Lmealorama_MealCourse$__amuseBouche };
var $t_Lmealorama_MealCourse$__appetizer = null;
function $u_Lmealorama_MealCourse$__appetizer(x) {
  $t_Lmealorama_MealCourse$__appetizer = x;
}
export { $t_Lmealorama_MealCourse$__appetizer as $t_Lmealorama_MealCourse$__appetizer, $u_Lmealorama_MealCourse$__appetizer as $u_Lmealorama_MealCourse$__appetizer };
var $t_Lmealorama_MealCourse$__soup = null;
function $u_Lmealorama_MealCourse$__soup(x) {
  $t_Lmealorama_MealCourse$__soup = x;
}
export { $t_Lmealorama_MealCourse$__soup as $t_Lmealorama_MealCourse$__soup, $u_Lmealorama_MealCourse$__soup as $u_Lmealorama_MealCourse$__soup };
var $t_Lmealorama_MealCourse$__fish = null;
function $u_Lmealorama_MealCourse$__fish(x) {
  $t_Lmealorama_MealCourse$__fish = x;
}
export { $t_Lmealorama_MealCourse$__fish as $t_Lmealorama_MealCourse$__fish, $u_Lmealorama_MealCourse$__fish as $u_Lmealorama_MealCourse$__fish };
var $t_Lmealorama_MealCourse$__salad = null;
function $u_Lmealorama_MealCourse$__salad(x) {
  $t_Lmealorama_MealCourse$__salad = x;
}
export { $t_Lmealorama_MealCourse$__salad as $t_Lmealorama_MealCourse$__salad, $u_Lmealorama_MealCourse$__salad as $u_Lmealorama_MealCourse$__salad };
var $t_Lmealorama_MealCourse$__mainCourse = null;
function $u_Lmealorama_MealCourse$__mainCourse(x) {
  $t_Lmealorama_MealCourse$__mainCourse = x;
}
export { $t_Lmealorama_MealCourse$__mainCourse as $t_Lmealorama_MealCourse$__mainCourse, $u_Lmealorama_MealCourse$__mainCourse as $u_Lmealorama_MealCourse$__mainCourse };
var $t_Lmealorama_MealCourse$__dessert = null;
function $u_Lmealorama_MealCourse$__dessert(x) {
  $t_Lmealorama_MealCourse$__dessert = x;
}
export { $t_Lmealorama_MealCourse$__dessert as $t_Lmealorama_MealCourse$__dessert, $u_Lmealorama_MealCourse$__dessert as $u_Lmealorama_MealCourse$__dessert };
var $t_Lmealorama_MealCourse$__cocktail = null;
function $u_Lmealorama_MealCourse$__cocktail(x) {
  $t_Lmealorama_MealCourse$__cocktail = x;
}
export { $t_Lmealorama_MealCourse$__cocktail as $t_Lmealorama_MealCourse$__cocktail, $u_Lmealorama_MealCourse$__cocktail as $u_Lmealorama_MealCourse$__cocktail };
var $t_Lmealorama_MealCourse$__canape = null;
function $u_Lmealorama_MealCourse$__canape(x) {
  $t_Lmealorama_MealCourse$__canape = x;
}
export { $t_Lmealorama_MealCourse$__canape as $t_Lmealorama_MealCourse$__canape, $u_Lmealorama_MealCourse$__canape as $u_Lmealorama_MealCourse$__canape };
var $t_Lmealorama_MealCourse$__bread = null;
function $u_Lmealorama_MealCourse$__bread(x) {
  $t_Lmealorama_MealCourse$__bread = x;
}
export { $t_Lmealorama_MealCourse$__bread as $t_Lmealorama_MealCourse$__bread, $u_Lmealorama_MealCourse$__bread as $u_Lmealorama_MealCourse$__bread };
var $t_Lmealorama_MealCourse$__snack = null;
function $u_Lmealorama_MealCourse$__snack(x) {
  $t_Lmealorama_MealCourse$__snack = x;
}
export { $t_Lmealorama_MealCourse$__snack as $t_Lmealorama_MealCourse$__snack, $u_Lmealorama_MealCourse$__snack as $u_Lmealorama_MealCourse$__snack };
var $t_Lmealorama_MealCourse$__preserve = null;
function $u_Lmealorama_MealCourse$__preserve(x) {
  $t_Lmealorama_MealCourse$__preserve = x;
}
export { $t_Lmealorama_MealCourse$__preserve as $t_Lmealorama_MealCourse$__preserve, $u_Lmealorama_MealCourse$__preserve as $u_Lmealorama_MealCourse$__preserve };
var $t_Lmealorama_MealCourse$__candy = null;
function $u_Lmealorama_MealCourse$__candy(x) {
  $t_Lmealorama_MealCourse$__candy = x;
}
export { $t_Lmealorama_MealCourse$__candy as $t_Lmealorama_MealCourse$__candy, $u_Lmealorama_MealCourse$__candy as $u_Lmealorama_MealCourse$__candy };
var $t_Lmealorama_MealCourse$__sauce = null;
function $u_Lmealorama_MealCourse$__sauce(x) {
  $t_Lmealorama_MealCourse$__sauce = x;
}
export { $t_Lmealorama_MealCourse$__sauce as $t_Lmealorama_MealCourse$__sauce, $u_Lmealorama_MealCourse$__sauce as $u_Lmealorama_MealCourse$__sauce };
var $t_Lmealorama_MealCourse$__sideDish = null;
function $u_Lmealorama_MealCourse$__sideDish(x) {
  $t_Lmealorama_MealCourse$__sideDish = x;
}
export { $t_Lmealorama_MealCourse$__sideDish as $t_Lmealorama_MealCourse$__sideDish, $u_Lmealorama_MealCourse$__sideDish as $u_Lmealorama_MealCourse$__sideDish };
var $t_Lmealorama_MealCourse$__subIngredient = null;
function $u_Lmealorama_MealCourse$__subIngredient(x) {
  $t_Lmealorama_MealCourse$__subIngredient = x;
}
export { $t_Lmealorama_MealCourse$__subIngredient as $t_Lmealorama_MealCourse$__subIngredient, $u_Lmealorama_MealCourse$__subIngredient as $u_Lmealorama_MealCourse$__subIngredient };
//# sourceMappingURL=mealorama.-Meal-Course$.js.map
